// src/routes/routes.jsx
import { createBrowserRouter } from "react-router-dom";
import App from "../App";
// import Regions from "../pages/Regions/Regions"; // Temporarily disabled - root now shows New England region
import Home from "../pages/Home/Home";
import Region from "../pages/Region/Region";
import Plan from "../pages/Plan/Plan";
import Stock from "../pages/Stock/Stock";
import Forbidden from "../pages/Forbidden/Forbidden";
import { FormProvider } from "../contexts/FormContext";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
        // Regions view is temporarily disabled - root now shows New England region
        {
            path: "",
            element: <Home />,
        },
        {
            path: ":regionSlug",
            element: <Region />,
        },
        {
            path: ":regionSlug/:planSlug",
            element: <Plan />,
        },
        {
            path: ":regionSlug/:planSlug/:stockSlug",
            element: (
              <FormProvider>
                <Stock />
              </FormProvider>
            ),
        },
        {
            path: "forbidden",
            element: <Forbidden />,
        },
    ],
  },
]);
